module.exports = __webpack_public_path__ + "img/undraw_happy_announcement_re_tsm0.a4c32686.svg";